/* eslint-disable functional/no-mixed-type */

export var ComparisonOperator;
(function (ComparisonOperator) {
  ComparisonOperator[ComparisonOperator["LT"] = -1] = "LT";
  ComparisonOperator[ComparisonOperator["EQ"] = 0] = "EQ";
  ComparisonOperator[ComparisonOperator["GT"] = 1] = "GT";
})(ComparisonOperator || (ComparisonOperator = {}));